<template>
  <div class="personal">
    <div class="personal-con">
      <div class="menu-content">
        <!-- <p class="menu-list">帐号设置</p> -->
        <p
          class="menu-list"
          :class="$route.query.info === 'user' ? 'menu-active' : ''"
          @click="gotoHref('user')"
        >
          账户信息
        </p>
        <p
          class="menu-list"
          :class="$route.query.info === 'safe' ? 'menu-active' : ''"
          v-if="!current_team_info.corp_id"
          @click="gotoHref('safe')"
        >
          账号安全
        </p>
        <p
          class="menu-list"
          :class="$route.query.info === 'auth' ? 'menu-active' : ''"
          @click="gotoHref('auth')"
        >
          我的授权
        </p>
        <p
          class="menu-list"
          :class="$route.query.info === 'download' ? 'menu-active' : ''"
          @click="gotoHref('download')"
        >
          样图下载
        </p>
      </div>

      <!--展示信息-->

      <div class="per-con">
        <div id="user-info" v-if="$route.query.info === 'user'">
          <div class="personal-item">
            <p style="line-height: 80px">头像</p>
            <p class="">
              <img :src="avatarURL" width="75" height="75" />
              <a
                href="javascript:;"
                class="r edit-avator"
                style="line-height: 80px"
                @click="toggleAvator"
                >修改</a
              >
            </p>
          </div>
          <div class="personal-item">
            <p>昵称</p>
            <p>
              <span>{{ nick_name }}</span>
              <a href="javascript:;" class="r" @click="nameOpen">修改</a>
            </p>
          </div>
          <div
            class="personal-item"
            v-if="loginInfo.is_company || loginInfo.company_vip_end_time"
          >
            <p>会员等级</p>
            <p>
              <span>
                企业VIP{{
                  loginInfo.company_vip_end_time && loginInfo.is_company
                    ? `（${loginInfo.company_vip_end_time}到期）`
                    : '（当前版本已过期）'
                }}
              </span>
            </p>
          </div>
          <div class="personal-item" v-if="current_team_info.corp_id">
            <p>部门</p>
            <p>
              <span>{{ department }}</span>
              <a href="javascript:;" class="r" @click="departmentNameOpen"
                >修改</a
              >
            </p>
          </div>
          <div class="personal-item">
            <p>用户ID</p>
            <p>
              <span>{{ loginInfo.uuid }}</span>
            </p>
          </div>
        </div>

        <div class="per-safe" v-if="$route.query.info === 'safe'">
          <div class="personal-item">
            <p>手机</p>
            <p>
              <span>{{ loginInfo.mobile || '未绑定' }}</span>
              <a
                href="javascript:;"
                class="r"
                @click="editInfo('mobile', Boolean(loginInfo.mobile))"
                >{{ loginInfo.mobile ? '修改' : '绑定' }}</a
              >
            </p>
          </div>
          <div class="personal-item">
            <p>邮箱</p>
            <div class="email-edit">
              <div v-if="!loginInfo.email">未绑定</div>
              <el-tooltip class="item" effect="dark" placement="top" v-else>
                <div slot="content">
                  <span>{{ emailSplit }}</span>
                </div>
                <div class="emails">
                  <span>{{ emailSplit }}</span>
                </div>
              </el-tooltip>
              <button
                class="email-unbind"
                @click="editEmail('unbind')"
                v-if="loginInfo.only_email == 0 && loginInfo.email"
              >
                解绑
              </button>
              <a
                href="javascript:;"
                class="r"
                @click="editEmail(!loginInfo.email ? 'bind' : 'edit')"
                >{{ !loginInfo.email ? '绑定' : '修改' }}</a
              >
            </div>
          </div>
          <div class="personal-item">
            <p>微信</p>
            <div class="email-edit">
              <div v-if="loginInfo.bind_wx" >已绑定</div>
              <div v-else >未绑定</div>
              <button
              v-if="loginInfo.bind_wx"
                class="email-unbind"
                @click="unbindWeixinCode('unbind')"
               
              >
                解绑
              </button>
              <a
              v-else 
                href="javascript:;"
                class="r"
                @click="bindWeixinCode(!loginInfo.email ? 'bind' : 'edit')"
              >
                绑定</a
              >
            </div>
            <!--  <p>
              <span>{{loginInfo.bind_wx ? '已绑定' : '未绑定'}}</span>
            </p> -->
          </div>
          <div class="personal-item" v-if="loginInfo.mobile || loginInfo.email">
            <p>密码</p>
            <p>
              <span>******</span>
              <a
                href="javascript:;"
                class="r"
                @click="editInfo('password', true)"
                >修改</a
              >
            </p>
          </div>
        </div>
        <div class="tip-box" v-if="$route.query.info === 'auth'">
          <img
            src="@/assets/image/shicon.png"
            alt=""
          />如需要授权书，联系您的客户代表
        </div>
        <Table
          v-if="
            $route.query.info === 'auth' || $route.query.info === 'download'
          "
        />
      </div>
    </div>

    <userDialog
      :title="'修改头像'"
      :visible="avatorStatus"
      @close="userAvatorClose"
      :width="'720px'"
      class="avator-model"
    >
      <el-row class="upload-tc">
        <el-upload
          action=""
          :show-file-list="false"
          :auto-upload="false"
          :on-change="uploadImg"
        >
          <el-button size="mini" type="primary">选择图片</el-button>
        </el-upload>
      </el-row>
      <el-row type="flex" justify="center">
        <div class="cropper">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="option.info"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixedBox="option.fixedBox"
            @realTime="realTime"
          ></vueCropper>
        </div>
        <div class="previewBox">
          <div :style="previews.div" class="preview">
            <img :src="previews.url" :style="previews.img" />
          </div>
        </div>
      </el-row>

      <div class="el-upload__tip" style="font-size: 12px; margin: 20px 0px">
        图片格式为jpg/jpeg或png，大小不超过5M
      </div>
      <div class="action-slider">
        <el-button
          icon="el-icon-minus"
          circle
          @click="changeScale(-1)"
        ></el-button>
        <!-- <el-slider
          v-model="option.scaleChangeNum"
          :step="10"
          @input="changeSlider"
        >
        </el-slider> -->
        <div class="slider">
          <span :style="{ left: spanLeft + 'px' }"></span>
        </div>
        <el-button
          icon="el-icon-plus"
          circle
          @click="changeScale(1)"
        ></el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="submit-btn" @click="saveEditAvatar">提 交</button>
      </span>
    </userDialog>

    <userDialog
      :width="'400px'"
      :visible="nameStatus"
      @close="nameClose"
      class="edit_name"
    >
      <div slot="title">
        <span>修改昵称</span>
      </div>
      <div>
        <p :class="nick_name === '' || !statusName ? 'error-info' : ''">
          <el-input
            type="text"
            v-model.trim="nick_name"
            maxlength="20"
            minlength="2"
          />
          <span v-if="nick_name === ''">请输入昵称</span>
          <span v-else-if="!statusName">请输入2-20位中文、英文或数字</span>
        </p>
        <div class="edit-name-footer">
          <button class="edit-name-button btn-cancel" @click="nameClose">
            取消
          </button>
          <button class="edit-name-button" @click="saveName">确定</button>
        </div>
      </div>
    </userDialog>
    <userDialog
      :width="'400px'"
      :visible="departmentNameVisable"
      @close="departmentNameVisable = false"
      class="edit_department_name"
    >
      <div slot="title">
        <span>修改部门</span>
      </div>
      <div>
        <p
          :class="
            department === '' || !statusdepartmentName ? 'error-info' : ''
          "
        >
          <el-input
            type="text"
            v-model.trim="department"
            maxlength="20"
            minlength="2"
          />
          <span v-if="department === ''">请输入部门</span>
          <span v-else-if="!statusdepartmentName"
            >请输入2-20位中文、英文或数字</span
          >
        </p>
        <div class="edit-department_name-footer">
          <button
            class="edit-department_name-button btn-cancel"
            @click="departmentNameClose"
          >
            取消
          </button>
          <button
            class="edit-department_name-button"
            @click="savedepartmentName"
          >
            确定
          </button>
        </div>
      </div>
    </userDialog>
    <editpassword
      v-if="passwordStatus"
      :passwordSmsCode="passwordSmsCode"
      @close="passwordClose"
    ></editpassword>

    <el-dialog
      title="身份验证"
      :visible.sync="dialogVisible"
      custom-class="authentication"
      :center="true"
      :close-on-click-modal="false"
      @close="cancel('auth')"
    >
      <el-form
        :model="authenticationForm"
        :rules="authenticationRules"
        ref="authenticationForm"
        class="authentication-form"
        @keyup.enter.native="authenticationSubmit"
      >
        <el-form-item label="当前手机：" prop="mobile" class="mobile">
          <el-input
            type="text"
            v-model.trim="authenticationForm.mobile"
            auto-complete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="code" class="codeImg">
          <el-input
            type="text"
            placeholder="图片验证码"
            v-model.trim="authenticationForm.code"
            auto-complete="off"
            maxlength="5"
          ></el-input>
          <img :src="url" @click="getImage" />
        </el-form-item>
        <el-form-item label="" prop="sms_code" class="sms-box">
          <el-input
            type="text"
            v-model.trim="authenticationForm.sms_code"
            auto-complete="off"
            placeholder="请输入验证码"
          ></el-input>
          <el-button
            @click="getSmsCode('authentication')"
            v-if="!count"
            class="authentication-btn"
            >获取验证码</el-button
          >
          <el-button v-else disabled class="authentication-btn getcode-btn"
            >{{ count }}秒后获取</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel('auth')">取消</el-button>
        <el-button type="primary" @click="authenticationOk">确认</el-button>
      </span>
    </el-dialog>
    <!-- 验证邮箱身份 -->
    <el-dialog
      title="身份验证"
      :visible.sync="dialogVisibleEmail"
      custom-class="authentication"
      :center="true"
      :close-on-click-modal="false"
      @close="cancel('auth')"
    >
      <el-form
        :model="authenticationForm"
        :rules="authenticationRules"
        ref="authenticationForm"
        class="authentication-form"
        @keyup.enter.native="authenticationSubmit"
      >
        <el-form-item label="当前邮箱：" prop="email" class="mobile">
          <el-input
            type="text"
            v-model.trim="authenticationForm.email"
            auto-complete="off"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="" prop="code" class="sms-box">
          <el-input
            type="text"
            v-model.trim="authenticationForm.code"
            auto-complete="off"
            placeholder="请输入验证码"
          ></el-input>
          <el-button
            @click="getSmsCode('email')"
            v-if="!count"
            class="authentication-btn"
            >获取验证码</el-button
          >
          <el-button v-else disabled class="authentication-btn getcode-btn"
            >{{ count }}秒后获取</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel('auth')">取消</el-button>
        <el-button type="primary" @click="authenticationemailOk"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="this.loginInfo.mobile ? '修改手机号' : '绑定手机号'"
      :visible.sync="mobileStatus"
      custom-class="mobile_model"
      :center="true"
      :close-on-click-modal="false"
      @close="cancel('mobile')"
    >
      <el-form
        :model="mobileForm"
        :rules="mobileRules"
        ref="mobileForm"
        class="mobile-form"
        @keyup.enter.native="nextMobile"
      >
        <el-form-item prop="mobile" class="form_mobile">
          <el-input
            type="text"
            v-model.trim="mobileForm.mobile"
            min="11"
            max="11"
            auto-complete="off"
            placeholder="请输入正确的手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code" class="codeImg">
          <el-input
            class="mobile-input"
            type="text"
            v-model.trim="mobileForm.code"
            placeholder="图形验证码"
            maxlength="5"
          ></el-input>
          <img :src="url" @click="getImage" />
        </el-form-item>
        <el-form-item label="" prop="mobile_code" class="sms-box">
          <el-input
            type="text"
            v-model.trim="mobileForm.mobile_code"
            auto-complete="off"
            placeholder="请输入验证码"
          ></el-input>
          <el-button
            @click="getSmsCode('mobile')"
            v-if="!count"
            class="mobile-btn"
            >获取验证码</el-button
          >
          <el-button v-else disabled class="mobile-btn getcode-btn"
            >{{ count }}秒后获取</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel('mobile')">取消</el-button>
        <el-button type="primary" @click="nextMobile">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="!loginInfo.email ? '绑定邮箱' : '修改邮箱'"
      :visible.sync="emailStatus"
      custom-class="email_model"
      :center="true"
      :close-on-click-modal="false"
      @close="cancel('email')"
    >
      <el-form
        :model="emailForm"
        :rules="emailRules"
        ref="emailForm"
        class="email-form"
        @keyup.enter.native="nextEmail"
      >
        <el-form-item prop="email" class="form_email">
          <el-input
            type="text"
            v-model.trim="emailForm.email"
            auto-complete="off"
            placeholder="请输入正确的邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="email_code" class="sms-box">
          <el-input
            type="text"
            v-model.trim="emailForm.email_code"
            auto-complete="off"
            placeholder="请输入验证码"
          ></el-input>
          <el-button
            @click="getSmsCode('email')"
            v-if="!count"
            class="email-btn"
            >获取验证码</el-button
          >
          <el-button v-else disabled class="email-btn getcode-btn"
            >{{ count }}秒后获取</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel('email')">取消</el-button>
        <el-button type="primary" @click="nextEmail">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="`${emailText}邮箱`"
      :visible.sync="unbindEmailStatus"
      custom-class="unbind_email_model"
      :center="true"
      :close-on-click-modal="false"
    >
      <el-form
        :model="emailForm"
        :rules="emailRules"
        ref="emailForm"
        class="email-form"
        @keyup.enter.native="nextEmail"
      >
        <el-form-item
          v-if="emailText == '修改'"
          prop="email"
          class="form_email"
          style="margin-top: 20px"
        >
          <el-input
            type="text"
            v-model.trim="emailForm.email"
            auto-complete="off"
            placeholder="请输入正确的邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item v-else label="当前邮箱：" prop="email" class="mobile">
          <el-input
            type="text"
            v-model.trim="emailForm.email"
            auto-complete="off"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="" prop="email_code" class="sms-box">
          <el-input
            type="text"
            v-model.trim="emailForm.email_code"
            auto-complete="off"
            placeholder="请输入验证码"
          ></el-input>
          <el-button
            @click="getSmsCode('email')"
            v-if="!count"
            class="email-btn"
            >获取验证码</el-button
          >
          <el-button v-else disabled class="email-btn getcode-btn"
            >{{ count }}秒后获取</el-button
          >
        </el-form-item>
      </el-form>

      <!-- <p class="unbind_tips">
            <span class="iconfont icon-warning"></span>
            请选择需要{{emailText}}的邮箱
        </p>
        <el-select v-model="unbindEmailValue" placeholder="请选择邮箱">
            <el-option
                v-for="(item, index) in emailSplit"
                :key="index"
                :label="item"
                :value="item">
            </el-option>
        </el-select> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUnbind('select')">取消</el-button>
        <el-button type="primary" @click="unbindEmail('select')"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="解绑邮箱确认"
      :visible.sync="confirmUnbindEmailStatus"
      custom-class="confirm_unbind_email_model"
      :center="true"
      :close-on-click-modal="false"
    >
      <p class="confirm_unbind">解绑邮箱后无法撤回，并且将无法使用邮箱登录！</p>
      <p class="confirm_unbind">您确定要删除吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUnbind('confrim')">取消</el-button>
        <el-button type="primary" @click="unbindEmail('confrim')"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!-- 微信绑定二维码 -->
    <el-dialog
      :title="loginInfo.bind_wx==1?'解绑微信':'绑定微信'"
      :visible.sync="dialogVisibleWx"
      custom-class="authentication"
      :center="true"
      :close-on-click-modal="false"
      @close="cancelWx"
    >
      <img v-if="(bind_code == 0 || bind_code == 1)&&!noMobile" :src="wxUrl" alt="" />
      <div v-else-if="bind_code == 2&&!noMobile" class="wxhas">
        <p class="title">您绑定的微信号已被占用，请更换微信号</p>
        <el-button type="primary" class="close" @click="dialogVisibleWx = false"
          >关闭</el-button
        ></div>
        <div class="wxhas" v-else-if="noMobile">
        <p class="title1">为了您的账户安全，请绑定手机号后才可解绑微信</p>
        <el-button type="primary" class="close" @click="editInfo('mobile', Boolean(loginInfo.mobile))"
          >去绑定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userDialog from '@/components/common/dialog.vue'
import Editpassword from './editpassword.vue'
import { Login, User } from '@/config/axios/new_api'
import tokenFunc from '@/config/static/token'
const img = require('../../../../assets/image/mobile_head.png')
import Table from './table.vue'
export default {
  components: { userDialog, Editpassword, Table },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        var reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*[\.,#?!@$%^&*-].*)[0-9A-Za-z\.,#?!@$%^&*-]{12,32}$/
        if (!reg.test(value)) {
          callback(
            new Error('密码由12-32位数字、大/小写字母、常用特殊字符组成')
          )
        }
        if (this.passwordForm.confirm_password !== '') {
          this.$refs.passwordForm.validateField('confirm_password')
        }
        callback()
      }
    }
    var mobileValidatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        var reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*[\.,#?!@$%^&*-].*)[0-9A-Za-z\.,#?!@$%^&*-]{12,32}$/
        if (!reg.test(value)) {
          callback(
            new Error('密码由12-32位数字、大/小写字母、常用特殊字符组成')
          )
        }
        callback()
      }
    }

    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        if (value.length > 16 || value.length < 6) {
          callback(new Error('密码长度在 6 到 16 个字符'))
        }
        if (!/^[0-9A-Za-z]{6,16}$/.test(value)) {
          callback(new Error('新密码只能输入大小写字母和数字'))
        }
        callback()
      }
    }
    var validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        let reg = /^1[0-9]{10}/
        if (!reg.test(value) || value.length !== 11) {
          callback(new Error('请输入正确的手机号'))
        }
        callback()
      }
    }
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱'))
      } else {
        // let reg = /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/
        if (!this.staticFunc.emailRegExp().test(value)) {
          callback(new Error('请输入正确的邮箱'))
        }
        callback()
      }
    }
    return {
      noMobile:false,
      login_timeout: 0,
      wxMsg:'',
      bind_code: '',
      dialogVisibleWx: false,
      bindWeixinLogin: '',
      wxUrl: '',
      url: '',
      avatarURL: img,
      avatorStatus: false,
      nameStatus: false,
      mobileStatus: false,
      passwordStatus: false,
      count: null, // 倒计时
      timer: null,
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 1, // 剪切后的图片质量（0.1-1）
        full: true, // 输出原图比例截图 props名full
        outputType: 'png', // 裁剪生成额图片的格式
        canMove: true, // 能否拖动图片
        original: false, // 上传图片是否显示原始宽高
        canMoveBox: false, // 能否拖动截图框
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 250,
        autoCropHeight: 250,
        fixedBox: true, // 截图框固定大小
        scaleNum: 0,
        scaleChangeNum: 0
      },
      previews: {},
      nick_name: '',
      passwordForm: {
        old_password: '',
        password: '',
        confirm_password: ''
      },
      passwordRules: {
        old_password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      mobileRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            validator: validateMobile,
            trigger: 'blur'
          }
        ],
        code: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ],
        mobile_code: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: mobileValidatePass, trigger: 'blur' }
        ]
      },
      mobileForm: {
        mobile: '',
        mobile_code: '',
        uuid: '',
        password: '',
        code: '',
        code_key: ''
      },
      department: '',
      departmentNameVisable: false,
      dialogVisible: false,
      dialogVisibleEmail: false,
      authenticationForm: {
        mobile: '',
        email: '',
        sms_code: '',
        code: '',
        code_key: '',
        type: 1
      },
      authenticationRules: {
        mobile: [{ required: false }],
        sms_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      currentAction: '', // 当前动作
      emailAction: '', // 邮箱动作
      type: 2, // 获取验证码以及身份验证的type
      passwordSmsCode: '', // 修改密码的验证码
      emailStatus: false,
      emailForm: {
        email: '',
        email_code: '',
        code: '',
        code_key: ''
      },
      emailRules: {
        email: [
          { required: true, message: '请输入正确的邮箱', trigger: 'blur' },
          {
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        email_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      unbindEmailStatus: false, // 解绑邮箱
      unbindEmailValue: '',
      confirmUnbindEmailStatus: false, // 确认解绑邮箱
      temp_sms_code: '',
      emailText: '解绑',
      isClock: false
    }
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo
    },
    current_team_info() {
      return this.$store.getters.currentTeam
    },
    spanLeft() {
      return (this.option.scaleNum / 10).toFixed(0) * (210 / 9)
    },
    // 判断中文英文或者数字
    statusName() {
      if (!/^[\u4E00-\u9FA5a-zA-Z0-9]{2,20}$/.test(this.nick_name)) {
        return false
      } else {
        return true
      }
    },
    // 判断中文英文或者数字
    statusdepartmentName() {
      if (!/^[\u4E00-\u9FA5a-zA-Z0-9]{2,20}$/.test(this.department)) {
        return false
      } else {
        return true
      }
    },
    emailSplit() {
      return this.loginInfo.email
    }
  },
  watch: {
    nick_name: function (newVal) {
      this.nick_name = newVal.replace(/\s*/g, '')
    }
  },
  created() {
    this.getDepartmentName()
  },
  mounted() {
    if (this.loginInfo.image_url) {
      this.avatarURL = this.loginInfo.image_url
    }
    this.nick_name = this.loginInfo.nick_name
  },
  methods: {
    cancelWx() {
      this.bind_code=''
      clearInterval(this.bindWeixinLogin)
    },
    bindWeixinCode(content) {
      // 超过300秒需要刷新二维码
      this.dialogVisibleWx = true

      //请求微信二维码并轮询
      loginSdk.requestAction('token_user').then((res) => {
        if (res.code == 0) {
          let data = {
            register_type: 1,
            bind: res.data.id //绑定的用户id
          }
          // userinfo = res.data;
          var utmParams = loginSdk.utmParams
          let loginParams = Object.assign(data, utmParams)
          loginSdk
            .requestAction('wechat_code', loginParams)
            .then((res) => {
              let { code, data } = res
              this.data = res.data
              if (code == 0) {
                this.wxUrl = data.url
                this.bindWeixinLogin = setInterval(() => {
                  this.bindWeixinLoginResult(data)
                }, 1000)
              } else {
                if (res.msg) {
                  Vue.prototype.$message.error(res.msg)
                }
              }
            })
            .catch((err) => {
              // Vue.prototype.$message.error(err.msg || err.data.msg);
            })
        }
      })

      // 关闭微信扫码
      // $("#bind-wx-content .close").click(function () {
      //   clearInterval(bindWeixinLogin);
      // });
    },
    bindWeixinLoginResult(data) {
      var check_data = {
        sign: data.sign,
        is_bind: 1
      }
      loginSdk
        .requestAction('check_weixin_login', check_data)
        .then((response) => {
          let { code, data, msg } = response
          if (code == 0) {
            let bind_code = data.bind_code
            let bind_msg = data.msg
            console.log(bind_code)
            if (bind_code === 0) {
              
              Vue.prototype.$message.success('绑定成功')
              this.wxMsg='已绑定'
              clearInterval(this.bindWeixinLogin)
              // content.find(".close").trigger("click");
              setTimeout(() => {
                window.location.reload()
              }, 1000)
            }
            if (bind_code === 1) {
              this.bind_code = 1
              this.login_timeout += 1000
              if (this.login_timeout >= 1000 * 300) {
                clearInterval(this.bindWeixinLogin)
                this.bindWeixinLogin = setInterval(()=>{this.bindWeixinLoginResult(data)}, 1000)
              }
            }
            if (bind_code === 2) {
              this.bind_code = 2
              Vue.prototype.$message.error(bind_msg)
              clearInterval(this.bindWeixinLogin)
            }
            if (bind_code === 3) {
              // content.find(".close").trigger("click");
              Vue.prototype.$message.error(bind_msg)
              clearInterval(this.bindWeixinLogin)
            }
            // switch (bind_code) {
            //   //绑定成功
            //   case 0:
            //     Vue.prototype.$message.success("绑定成功");
            //     clearInterval(this.bindWeixinLogin);
            //     content.find(".close").trigger("click");
            //     setTimeout(() => {
            //       window.location.reload();
            //     }, 1000);
            //     break;
            //   //等待扫码
            //   case 1:
            //     login_timeout += 1000;
            //     if (login_timeout >= 1000 * 300) {
            //       clearInterval(this.bindWeixinLogin);
            //       this.bindWeixinLogin = setInterval(bindWeixinLoginResult, 1000);
            //       console.log(bind_msg,22222222222);
            //     }
            //     break;

            //   //已被他人绑定
            //   case 2:
            //     // content.find(".close").trigger("click");
            //     this.$message.error(bind_msg);
            //     console.log(bind_msg,22222222222);
            //     clearInterval(this.bindWeixinLogin);
            //     let error_box = $("#bind_wechat_error");
            //     $.mytools.widget.getmodalshow(error_box);
            //     error_box.find(".confirm-act").click(function () {
            //       $.mytools.widget.getmodalhide(error_box);
            //     });
            //     break;

            //   //绑定失败请重新尝试
            //   case 3:
            //     content.find(".close").trigger("click");
            //     Vue.prototype.$message.error(bind_msg);
            //     clearInterval(this.bindWeixinLogin);
            //     break;
            //   default:
            //     console.log('default');
            // }
          } else {
            this.login_timeout += 1000
            if (this.login_timeout >= 1000 * 300) {
              clearInterval(this.bindWeixinLogin)
              this.bindWeixinLogin = setInterval(()=>{this.bindWeixinLoginResult(data)}, 1000)
            }
            if (msg) {
              Vue.prototype.$message.error(msg)
            }
          }
        })
        .catch((error) => {
          if (error.msg) {
            Vue.prototype.$message.error(error.msg)
          }
        })
    },

    //解绑微信
    unbindWeixinCode(content) {
      this.dialogVisibleWx = true
      // 超过300秒需要刷新二维码
      if(!this.loginInfo.mobile&&!this.loginInfo.email)this.noMobile=true

      //请求微信二维码并轮询
      loginSdk.requestAction('token_user').then((res) => {
        if (res.code == 0) {
          let data = {
            register_type: 1,
            unbind: res.data.id //绑定的用户id
          }
          var utmParams = loginSdk.utmParams
          let loginParams = Object.assign(data, utmParams)
          loginSdk
            .requestAction('wechat_code', loginParams)
            .then((res) => {
              let { code, data } = res
              if (code == 0) {
                this.wxUrl = data.url
                this.bindWeixinLogin = setInterval(()=>{this.unbindWeixinLoginResult(data)}, 1000)
                this.unbindWeixinLoginResult(data)
               
              } else {
                if (res.msg) {
                  Vue.prototype.$message.error(res.msg)
                }
              }
            })
            .catch((err) => {
              // Vue.prototype.$message.error(err.msg || err.data.msg);
            })
        }
      })

      // 关闭微信扫码
      // $("#unbind-wx-content .close").click(function () {
      //   clearInterval(bindWeixinLogin);
      // });
    },
    //解绑微信
     unbindWeixinLoginResult(data) {
                  var check_data = {
                    sign: data.sign,
                    is_unbind: 1
                  }
                  loginSdk
                    .requestAction('check_weixin_login', check_data)
                    .then((response) => {
                      let { code, data, msg } = response
                      if (code == 0) {
                        let bind_code = data.unbind_code
                        let bind_msg = data.msg
                        switch (bind_code) {
                          case 0:
                          this.wxMsg='未绑定'
                            Vue.prototype.$message.success(bind_msg)
                            clearInterval(this.bindWeixinLogin)
                            setTimeout(() => {
                              window.location.reload()
                            }, 1000)
                            break
                          //等待扫码
                          case 1:
                            this.login_timeout += 1000
                            if (login_timeout >= 1000 * 300) {
                              clearInterval(this.bindWeixinLogin)
                              this.bindWeixinLogin = setInterval(
                              ()=>{this.unbindWeixinLoginResult(data)},
                                1000
                              )
                            }
                            break

                          case 2:
                            Vue.prototype.$message.error(bind_msg)
                            clearInterval(this.bindWeixinLogin)
                            this.dialogVisibleWx=false
                            break

                          //绑定失败请重新尝试
                          case 3:
                            Vue.prototype.$message.error(bind_msg)
                            clearInterval(this.bindWeixinLogin)
                            break
                        }
                      } else {
                        this.login_timeout += 1000
                        if (this.login_timeout >= 1000 * 300) {
                          clearInterval(this.bindWeixinLogin)
                          this.bindWeixinLogin = setInterval(
                          ()=>{this.unbindWeixinLoginResult(data)},
                            1000
                          )
                        }
                        if (msg) {
                          content.find('.close').trigger('click')
                          Vue.prototype.$message.error(msg)
                        }
                      }
                    })
                    .catch((error) => {
                      if (error.msg) {
                        Vue.prototype.$message.error(error.msg)
                      }
                    })
                },
    //获刷新图形码
    async getImage() {
      loginSdk.requestAction('image_code').then((res) => {
        if (res.code == 0) {
          var data = res.data
          this.url = data.base64
          this.authenticationForm.code = this.mobileForm.code = ''
          this.authenticationForm.code_key = this.mobileForm.code_key = data.key
        }
      })
    },
    async getSmsCode(type) {
      if (this.isClock) return
      this.isClock = true
      if (type !== 'email') {
        let mes_params = {
          type: this.type, // 2修改 3绑定
          mobile:
            type == 'authentication'
              ? this.authenticationForm.mobile
              : this.mobileForm.mobile,
          imgcode:
            type == 'authentication'
              ? this.authenticationForm.code
              : this.mobileForm.code,
          codekey:
            type == 'authentication'
              ? this.authenticationForm.code_key
              : this.mobileForm.code_key
        }
        loginSdk
          .requestAction('mes_send_after', mes_params)
          .then((res) => {
            if (res.code == 0) {
              const TIME = 60
              if (!this.timer) {
                this.count = TIME
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME) {
                    this.count--
                  } else {
                    clearInterval(this.timer)
                    this.timer = null
                    this.count = null
                    this.isClock = false
                  }
                }, 1000)
              }
            } else {
              this.isClock = false
              this.$message.error(res.msg)
              this.getImage()
            }
          })
          .catch((error) => {
            this.getImage()
          })
      } else {
        let mes_params = {
          type: this.loginInfo.email ? 2 : 3, // 2修改 1绑定
          email: this.emailForm.email
        }

        loginSdk
          .requestAction('email_code', mes_params)
          .then((res) => {
            if (res.code == 0) {
              const TIME = 60
              if (!this.timer) {
                this.count = TIME
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME) {
                    this.count--
                  } else {
                    clearInterval(this.timer)
                    this.timer = null
                    this.count = null
                    this.isClock = false
                  }
                }, 1000)
              }
            } else {
              this.isClock = false
              this.$message.error(res.msg)
              this.getImage()
            }
          })
          .catch((err) => {
            this.getImage()
          })
      }
    },
    getDepartmentName() {
      let department = ''
      this.loginInfo.teams.forEach((item) => {
        if (item.team_id === this.current_team_info.id) {
          this.department = item.department
          department = item.department
        }
      })
      return department
    },
    editInfo(val, type) {
      this.isClock = false
      this.dialogVisibleWx=false
      this.authenticationForm.mobile = this.loginInfo.mobile
      this.authenticationForm.email = this.loginInfo.email
      this.type = type ? 2 : 3
      this.currentAction = val
      this.getImage()
      if (val == 'mobile' && this.loginInfo.email == '' && !type) {
        this.type = 3
        this.mobileStatus = true
        this.getImage()
        return
      }
      if (this.loginInfo.mobile) {
        this.dialogVisible = true
      } else if (this.loginInfo.email) {
        this.dialogVisibleEmail = true
        this.emailForm.email = this.authenticationForm.email
      }
    },
    editEmail(type) {
      this.isClock = false
      this.authenticationForm.mobile = this.loginInfo.mobile
      this.authenticationForm.email = this.loginInfo.email
      this.currentAction = 'email'
      this.getImage()
      this.emailAction = type
      this.type = type === 'edit' ? 2 : 3
      if (!this.loginInfo.mobile && this.loginInfo.email == '') {
        if (this.loginInfo.email) {
          this.unbindEmailStatus = true
          if (this.emailAction === 'edit') {
            this.emailForm.email = ''
            this.emailText = '修改'
          } else {
            this.emailForm.email = this.loginInfo.email
            this.emailText = '解绑'
          }
        } else {
          if (this.emailAction === 'bind') {
            this.emailStatus = true
          } else if (this.emailAction === 'edit') {
            this.emailStatus = true
          } else {
            this.confirmUnbindEmailStatus = true
          }
        }
        return
      }

      if (this.loginInfo.mobile) {
        this.dialogVisible = true
      } else if (this.loginInfo.email) {
        this.emailForm.email = this.authenticationForm.email
        this.dialogVisibleEmail = true
      }
    },
    gotoHref(info) {
      this.$router.replace({
        name: 'User',
        query: { info }
      })
    },
    getUserInfo() {
      Login.getUserInfo().then((res) => {
        if (res.status === 1) {
          this.nick_name = res.data.nick_name
          this.$store.commit('loginInfo', res.data)
          this.$store.commit('logoForm', {
            logo: res.data.current_team_logo,
            name: res.data.current_team_name
          })
        }
      })
    },
    toggleAvator() {
      // 切换修改头像打开
      this.avatorStatus = true
      this.option.img = this.loginInfo.image_url
    },
    userAvatorClose() {
      // 头像关闭
      this.avatorStatus = false
    },
    nameOpen() {
      this.nameStatus = true
    },
    nameClose() {
      this.nameStatus = false
      this.nick_name = this.loginInfo.nick_name
    },
    saveEditAvatar() {
      // 保存
      this.avatorStatus = false
      this.finish('data')
    },
    // 保存名字
    saveName() {
      if (!tokenFunc.getToken()) {
        this.staticFunc.toHref(process.env.VUE_APP_BASELogout)
      }
      if (this.nick_name === '' || !this.statusName) {
        return false
      }
      loginSdk.requestAction('token_user').then((res) => {
        if (res.code == 0) {
          var data = {
            id: res.data.id,
            nickname: this.nick_name
          }
          loginSdk.requestAction('edit_nickname', data).then((res) => {
            if (res.code == 0) {
              this.$message.success('昵称修改成功')
              this.getUserInfo()
              this.nameStatus = false
            } else {
              Vue.prototype.$message.error(res.msg)
            }
          })
        }
      })
    },
    passwordClose() {
      this.passwordStatus = false
    },
    nextMobile() {
      let { mobile, mobile_code } = this.mobileForm
      this.$refs.mobileForm.validate((valid) => {
        if (valid) {
          let params = {
            mobile,
            sms_code: mobile_code,
            vercode: mobile_code
          }
          let url = ''
          if (this.loginInfo.mobile != '') {
            params.type = 2
            url = 'change_bind_mobile'
          } else {
            params.type = 3
            url = 'qiye_bind_mobile'
          }
          loginSdk
            .requestAction(url, params)
            .then((res) => {
              if (res.code == 0) {
                if (this.loginInfo.mobile) {
                  this.$message.success('手机号修改成功')
                } else {
                  this.$message.success('手机号绑定成功')
                  this.noMobile=false
                }
                this.getUserInfo()
                this.mobileStatus = false
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch((error) => {
              this.catchMessage(res.msg)
            })
        }
      })
    },
    nextEmail() {
      let { email, email_code } = this.emailForm
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          let params = {
            email,
            vercode: email_code
          }
          let url
          if (this.loginInfo.email) {
            params.old_email = this.loginInfo.email
            url = 'email_change'
          } else {
            url = 'bind_email'
          }
          loginSdk.requestAction(url, params).then((res) => {
            if (res.code == 0) {
              if (this.loginInfo.email) {
                this.$message.success('邮箱修改成功')
              } else {
                this.$message.success('邮箱绑定成功')
              }
              this.getUserInfo()
              this.emailStatus = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 放大/缩小
    changeScale(num) {
      num = num || 1
      this.option.scaleNum += num * 10
      if (num === 1) {
        if (this.option.scaleNum >= 100) {
          this.option.scaleNum = 90
        } else {
          this.$refs.cropper.changeScale(num)
        }
      } else if (num === -1) {
        if (this.option.scaleNum < 0) {
          this.option.scaleNum = 0
        } else {
          this.$refs.cropper.changeScale(num)
        }
      }
    },
    // 保存上传图片
    finish(type) {
      if (!tokenFunc.getToken()) {
        this.staticFunc.toHref(process.env.VUE_APP_BASELogout)
        return
      }
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob((data) => {
          this.avatarURL = window.URL.createObjectURL(data)
          this.editImg()
        })
      } else {
        this.$refs.cropper.getCropData((data) => {
          //访问接口保存到数据库写这儿!
          this.avatarURL = data
          this.editImg()
        })
      }
    },
    editImg() {
      loginSdk.requestAction('token_user').then((res) => {
        if (res.code == 0) {
          var user_id = res.data.id
          let data = {
            id: user_id,
            image_url: this.avatarURL
          }
          //edit_head_image
          loginSdk
            .requestAction('upload_headimage', data)
            .then((res) => {
              if (res.code == 0) {
                let editData = {
                  id: user_id,
                  image_url: res.data.url
                }

                loginSdk
                  .requestAction('edit_head_image', editData)
                  .then((res) => {
                    if (res.code == 0) {
                      let { data } = res
                      this.$message.success('修改头像成功')
                      this.getUserInfo()
                    } else {
                      this.$message.error(res.message)
                    }
                  })
                  .catch((err) => {
                    Vue.prototype.$message.error(err.data.msg)
                  })
              } else {
                Vue.prototype.$message.error(res.msg)
              }
            })
            .catch((err) => {
              Vue.prototype.$message.error(err.msg || err.data.msg)
            })
        }
      })

      /* let params = {
        upload_type: 'images',
        image_url: this.avatarURL
      }
      User.upLoadBase64(params).then(res=>{
          if (res.status === 1) {
            User.changeImage({image_url: res.data.url}).then(res=>{
                if(res.status === 1) {
                    this.$message.success('修改头像成功')
                    this.getUserInfo()
                }else{
                    this.$message.error(res.message)
                }
            }).catch(error => {
                this.$message.error(error.message)
            })
          } else {
            this.$message.error(res.message)
          }
        }).catch(error => {
            // this.$message.error(error.message)
        }) */
    },
    // 实时预览函数
    realTime(data) {
      const that = this
      this.$refs.cropper.getCropBlob((data) => {
        // 这里data数据为Blob类型，blobToDataURI方法转换成base64
        this.blobToDataURI(data, function (res) {
          that.previews.url = res
          that.$forceUpdate()
        })
      })
    },
    blobToDataURI(blob, callback) {
      var reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onload = function (e) {
        callback(e.target.result)
      }
    },
    // 更换头像--上传本地图片
    uploadImg(file) {
      var _this = this
      var reader = new FileReader()
      var dotIndex = file.name.lastIndexOf('.') + 1
      var fileTypeStr = file.name.slice(dotIndex)
      let img = ['png', 'jpeg', 'jpg']
      if (!img.includes(fileTypeStr)) {
        this.$message({
          message: '请上传png、jpeg、jpg图片',
          center: true,
          customClass: 'handle-success'
        })
        return
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error('图片大小不能超过5M')
        return
      }
      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        _this.option.img = data
      }
      // 转化为base64
      reader.readAsDataURL(file.raw)
      // 转化为blob
      // reader.readAsArrayBuffer(file.raw);
    },
    departmentNameOpen() {
      this.departmentNameVisable = true
    },
    departmentNameClose() {
      this.departmentNameVisable = false
      this.department = this.getDepartmentName()
    },
    savedepartmentName() {
      // 保存部门
      if (this.department === '' || !this.statusdepartmentName) {
        return false
      }
      User.changeDepartment({
        department: this.department,
        team_id: this.loginInfo.current_team_id
      }).then((res) => {
        if (res.status == 1) {
          this.departmentNameVisable = false
          this.getUserInfo()
          this.$message.success('更新成功！')
        }
      })
    },
    cancel(type) {
      this.isClock = false
      clearInterval(this.timer)
      this.timer = null
      this.count = null
      if (type === 'auth') {
        this.authenticationForm.code = ''
        this.authenticationForm.code_key = ''
        this.dialogVisible = false
        this.dialogVisibleEmail = false

        this.$refs['authenticationForm'].resetFields()
      } else if (type === 'mobile') {
        this.mobileForm.code = ''
        this.mobileForm.mobile = ''
        this.mobileForm.mobile_code = ''
        this.mobileStatus = false
        this.$refs['mobileForm'].resetFields()
      } else {
        this.emailForm.email = ''
        this.emailForm.email_code = ''
        this.emailStatus = false
        this.$refs['emailForm'].resetFields()
      }
    },
    cancelUnbind(type){
      if (type === 'confrim') {
        this.confirmUnbindEmailStatus = false
      } else {
        this.unbindEmailValue = ''
        this.unbindEmailStatus = false
      }
    },
    unbindEmail(type){
      let params = {
        email: this.emailForm.email,
            sms_code: this.emailForm.email_code,
      }
        let url = '';
        if(this.emailAction === 'edit'){
        this.emailText = '修改'
            url = 'email_change';
            params.old_email = this.loginInfo.email;
            params.code = this.emailForm.email_code;
        }else{
        this.emailText = '解绑'
            url = 'email_unbind';
      }
        loginSdk.requestAction(url,params).then(res=>{
          if(res.code == 0){
            if(this.loginInfo.email){
              this.$message.success("邮箱修改成功");
            }else{
              this.$message.success("邮箱解绑成功");
          }
            location.reload();
            this.getUserInfo();
          this.emailStatus = false
          }else{
            this.$message.error(res.msg);
        }
      })
      return false;
      if (type === 'select') {
        if (this.emailAction === 'edit') {
          this.emailStatus = true
        } else {
          this.confirmUnbindEmailStatus = true
        }
        // this.unbindEmailValue = ''
        this.unbindEmailStatus = false
      } else {
            let url = '';
            if(this.loginInfo.mobile) {
          url = User.emailUnbind
            }else {
          url = User.emailUnbindNoMobile
        }
            url(params).then(res=>{
                if(res.status === 1){
              this.$message.success('邮箱解绑成功')
              this.confirmUnbindEmailStatus = false
              this.unbindEmailValue = ''
              this.getUserInfo()
                }else{
              his.$message.error(res.message)
            }
            }).catch(err => {
            // this.$message.error(err.message)
          })
      }
    },
    authenticationOk() {
      this.$refs['authenticationForm'].validate((valid) => {
        if (valid) {
          let params = {
            type: this.type,
            vercode: this.authenticationForm.sms_code,
            mobile: this.loginInfo.mobile,
            imgcode: this.authenticationForm.code,
            imgsrc: this.url,
            codekey: this.authenticationForm.code_key
          }
          loginSdk.requestAction('mobile_verification', params).then((res) => {
            if (res.code == 0) {
              this.temp_sms_code = this.authenticationForm.sms_code
              this.dialogVisible = false
              clearInterval(this.timer)
              this.timer = null
              this.count = null
              this.authenticationForm.code = ''
              this.authenticationForm.code_key = ''
              if (this.currentAction === 'mobile') {
                this.mobileStatus = true
                this.getImage()
              } else if (this.currentAction === 'email') {
                if (this.emailSplit.length > 1) {
                  this.unbindEmailStatus = true
                  this.unbindEmailValue = ''
                  if (this.emailAction === 'edit') {
                    this.emailText = '修改'
                  } else {
                    this.emailForm.email = this.loginInfo.email
                    this.emailText = '解绑'
                  }
                } else {
                  if (this.emailAction === 'bind') {
                    this.emailStatus = true
                  } else if (this.emailAction === 'edit') {
                    this.emailStatus = true
                  } else {
                    this.confirmUnbindEmailStatus = true
                  }
                }
              } else {
                this.passwordStatus = true
                this.passwordSmsCode = this.temp_sms_code
              }
            } else {
              Vue.prototype.$message.error(res.msg)
            }
          })
        }
      })
    },
    authenticationemailOk() {
      this.isClock = false
      this.$refs['authenticationForm'].validate((valid) => {
        if (valid) {
          let params = {
            email: this.authenticationForm.email,
            code: this.authenticationForm.code,
            type: 2,
            vercode: this.authenticationForm.sms_code,
            mobile: this.loginInfo.mobile,
            imgcode: this.authenticationForm.code,
            imgsrc: this.url,
            codekey: this.authenticationForm.code_key
          }
          loginSdk.requestAction('check_email', params).then((res) => {
            if (res.code == 0) {
              this.temp_sms_code = this.authenticationForm.sms_code
              this.dialogVisibleEmail = false
              clearInterval(this.timer)
              this.timer = null
              this.count = null
              this.emailForm.code = ''
              this.emailForm.sms_code = ''
              this.emailForm.email = ''
              this.authenticationForm.email = ''
              this.authenticationForm.code = ''
              this.authenticationForm.code_key = ''
              if (this.currentAction === 'mobile') {
                this.mobileStatus = true
                this.getImage()
              } else if (this.currentAction === 'email') {
                if (this.emailSplit.length > 1) {
                  this.unbindEmailStatus = true
                  this.unbindEmailValue = ''
                  if (this.emailAction === 'edit') {
                    this.emailText = '修改'
                  } else {
                    this.emailText = '解绑'
                  }
                } else {
                  if (this.emailAction === 'bind') {
                    this.emailStatus = true
                  } else if (this.emailAction === 'edit') {
                    this.emailStatus = true
                  } else {
                    this.confirmUnbindEmailStatus = true
                  }
                }
              } else {
                this.passwordStatus = true
                this.passwordSmsCode = this.temp_sms_code
              }
            } else {
              Vue.prototype.$message.error(res.msg)
            }
          })
        }
      })
    },
    logout() {
      var token = localStorage.token ? JSON.parse(localStorage.token) : ''
      loginSdk
        .requestAction('logout', { token: token })
        .then((res) => {
          if (res.code == 0) {
            window.sessionStorage.clear()
            this.$store.commit('loginInfo', null)
            this.staticFunc.toHref(process.env.VUE_APP_BASELogout)
            return
          }
        })
        .catch((error) => {})
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.wxhas {
  width: 400px;
  height: 260px;
  position: relative;
  .title {
    position: absolute;
    top: 90px;
    left: 30px;
    height: 23px;
    font-size: 16px;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
  }
  .title1 {
    position: absolute;
    top: 90px;
    height: 23px;
    font-size: 16px;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
  }
  .close {
    position: absolute;
    top: 180px;
    left: 80px;
    background: #7966ff;
    width: 200px;
    height: 32px;
    margin: 0 auto;
    cursor: pointer;
    text-align: center;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    line-height: 8px;
  }
}
.personal {
  background: #f7f7f7;
  height: 100vh;
  .personal-con {
    width: 1200px;
    margin: 0 auto;
    padding-top: 70px;
    display: flex;
  }
  .menu-content {
    @include wh(252px, 580px);
    padding-top: 20px;
    border-radius: 0px 0px 0px 4px;
    background: #fff;
    .menu-list {
      @include wh(100%, 60px);
      @include lineH(60px);
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      &.menu-active {
        background: rgba(121, 102, 255, 0.08);
        position: relative;
        color: #7966ff;
        &::after {
          display: block;
          content: '';
          @include wh(6px, 60px);
          background: #7966ff;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }

  .per-con {
    background: #fff;
    flex: 1;
    margin-left: 20px;
    padding: 0 40px;
    .personal-item {
      display: flex;
      width: 100%;
      > p {
        height: 100%;
        font-size: 16px;
        padding-top: 30px;
        padding-bottom: 30px;
        &:first-child {
          width: 96px;
        }
        &:last-child {
          border-bottom: solid 1px #dedede;
          margin-left: 32px;
          width: 711px;
          position: relative;
          img {
            border-radius: 50%;
            background: #ebebeb;
            object-fit: cover;
          }
          section {
            width: calc(100% - 200px);
            height: 100%;
            overflow-x: auto;
          }
          a {
            width: 58px;
            height: 30px;
            text-align: center;
            line-height: 30px !important;
            border: 1px solid #5a2df5;
            border-radius: 4px;
            font-size: 14px;
          }
          .edit-avator {
            position: absolute;
            right: 0;
            top: calc((100% - 30px) / 2);
          }
        }
        .r {
          color: #7966ff;
          cursor: pointer;
        }
      }
    }
  }
  .avator-model {
    ::v-deep( .model) {
      .model__body {
        padding: 30px 40px;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.previewBox {
  text-align: center;
  margin-left: 60px;
  padding-top: 30px;
}

.preview {
  width: 150px;
  height: 150px;
  margin: 0px auto 20px auto;
  border-radius: 50%;
  border: 1px solid #ccc;
  background-color: #fff;
  overflow: hidden;
  border: 2px solid rgba(198, 198, 198, 1);
}

.cropper {
  width: 360px;
  height: 280px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7f7f7;
  overflow: hidden;
}
.vue-cropper {
  width: 220px !important;
  height: 220px !important;
  background: #fff;
  border-radius: 50%;
  overflow: hidden;
}
.cropper-modal {
  border-radius: 50%;
}
::v-deep( .cropper-view-box) {
  background: #fff;
}
.upload-tc {
  margin: 0 0 31px 0;
}
.action-slider {
  width: 275px;
  @include flex(center, space-between);
  .slider {
    position: relative;
    display: inline-block;
    width: 210px;
    height: 12px;
    background: #eaeaea;
    border-radius: 2px;
    span {
      position: absolute;
      display: block;
      width: 4px;
      height: 12px;
      background: #7966ff;
      border-radius: 2px;
      margin-left: 0px;
      cursor: pointer;
    }
  }
  // ::v-deep( .el-slider__runway {
  //   position: relative;
  //   display: inline-block;
  //   width: 210px;
  //   height: 12px;
  //   background: #eaeaea;
  //   border-radius: 2px;
  // }
  // ::v-deep( .el-slider__bar {
  //   height: 12px;
  // }
  // ::v-deep( .el-slider__button-wrapper {
  //   top: -12px;
  // }
  button {
    width: 20px;
    height: 20px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  }
}

.submit-btn {
  display: block;
  width: 172px;
  text-align: center;
  color: #fff;
  margin: 0 auto;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  background: #7966ff;
  border-radius: 4px;
}
.edit_name,
.edit_department_name {
  ::v-deep( .model) {
    height: 230px;
    input {
      border: 1px solid #e1e1e1;
    }
  }
  ::v-deep( .model-title) {
    position: relative;
    margin-bottom: 20px;
    text-align: center;
    font-size: 26px;
    font-weight: bold;
  }
  ::v-deep( .model__header) {
    background: #fff;
    color: #333;
    box-shadow: none;
    height: 70px;
    line-height: 70px;
    position: relative;
    padding: 0 24px;
    text-align: left;
    border-bottom: 2px solid #f7f6f9;
    font-size: 16px;
    .close {
      width: 25px;
      height: 25px;
      top: 22px;
      right: 23px;
      .iconfont {
        color: #999999;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  ::v-deep( .model__body) {
    padding: 24px;
    .error-info {
      position: relative;
      span {
        position: absolute;
        left: 0;
        top: 50px;
      }
    }
    .edit-name-footer,
    .edit-department_name-footer {
      text-align: right;
      .edit-name-button,
      .edit-department_name-button {
        width: 88px;
        height: 40px;
        display: inline-block;
        background-color: #5a2df5;
        color: #fff;
        border-radius: 4px;
      }
      .btn-cancel {
        background-color: #fff;
        color: #2d2d32;
        border: 1px solid #e1e1e1;
        margin-right: 16px;
      }
    }
  }
  .title-xs {
    position: absolute;
    right: 165px;
    bottom: 0px;
  }
}
.password_model {
  ::v-deep( .model) {
    height: 600px;
  }
}
#code-img-t {
  display: block;
  position: absolute;
  top: 48px;
  right: 0px;
  color: #7966ff;
  left: auto;
  cursor: pointer;
  line-height: 1;
}
::v-deep( .authentication),
::v-deep( .mobile_model),
::v-deep( .email_model),
::v-deep( .unbind_email_model),
::v-deep( .confirm_unbind_email_model) {
  width: 400px;
  min-height: 100px;
  border-radius: 4px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  .el-dialog__header {
    height: 70px;
    line-height: 70px;
    padding: 0 24px;
    text-align: left;
    border-bottom: 2px solid #f7f6f9;
    .el-dialog__title {
      font-size: 16px;
      font-weight: bold;
      color: #3b3946;
    }
  }
  .el-dialog__body {
    padding: 0 24px;
    .current_phone {
      height: 68px;
      line-height: 68px;
      color: #3c3c43;
      font-size: 14px;
    }
    .el-select {
      width: 100%;
      height: 42px;
      margin-bottom: 14px;
    }
    .confirm_unbind {
      margin-top: 24px;
      &:last-child {
        margin-top: 7px;
        margin-bottom: 24px;
      }
    }
    .authentication-form,
    .mobile-form,
    .email-form {
      .mobile {
        display: flex;
        margin-bottom: 0;
        height: 68px;
        align-items: center;
        .el-form-item__label {
          padding: 0;
        }
        .el-form-item__content {
          flex: 1;
          .el-input__inner {
            border: none;
            padding: 0;
            background-color: #fff;
          }
        }
      }
      .codeImg,
      .sms-box {
        .el-form-item__content {
          display: flex;
          img {
            width: 90px;
            height: 40px;
            margin-left: 8px;
            text-align: center;
            border-radius: 4px;
            border: 1px solid #e1e1e1;
          }
          .authentication-btn,
          .mobile-btn,
          .email-btn {
            padding: 0;
            margin-left: 8px;
            height: 40px;
            span {
              display: block;
              width: 90px;
              height: 42px;
              line-height: 42px;
            }
            &.getcode-btn {
              background: #f7f6f9;
              font-size: 14px;
              span {
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3b3946;
                line-height: 42px;
              }
            }
          }
        }
      }
    }
  }
  .el-dialog__footer {
    text-align: right;
    .el-button {
      width: 88px;
      height: 40px;
      font-size: 14px;
    }
  }
}
.email-edit {
  position: relative;
  margin-left: 32px;
  display: flex;
  justify-content: space-between;
  width: 711px;
  border-bottom: solid 1px #dedede;
  padding: 30px 0;
  .emails {
    width: calc(100% - 200px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .email-unbind {
    width: 58px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    position: absolute;
    top: 30px;
    right: 66px;
    border-radius: 4px;
    background-color: #f7f7f7;
    color: #f54531;
  }
  a {
    width: 58px;
    height: 30px;
    text-align: center;
    line-height: 30px !important;
    border: 1px solid #5a2df5;
    border-radius: 4px;
    font-size: 14px;
  }
}
.unbind_tips {
  height: 36px;
  background-color: #fffbf0;
  color: #d48621;
  line-height: 36px;
  padding-left: 8px;
  margin: 16px 0;
  .iconfont {
    color: #faa932;
  }
}
::v-deep( .mobile_model),
::v-deep( .email_model) {
  .el-dialog__body {
    padding: 24px 24px 0;
  }
}
.tip-box {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
  width: 828px;
  margin: 32px auto 0;
  img {
    width: 16px;
    margin-right: 6px;
    vertical-align: -4px;
  }
}
</style>
